


import React, { useEffect, useState, } from 'react'

import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';


import Header from '../inc/Header';
// import Uploadpres from '../pages/Uploadpres';
import { Badge, Dropdown, Container, Nav, Form, FormControl, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { storage } from '../../firebase';
import { ref, uploadBytes, listAll, getDownloadURL } from "firebase/storage";
import { v4 } from "uuid";




import { v4 as uuidv4 } from "uuid";

import { Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom'
import { useUserAuth } from '../../contexts/UserAuthContext'
import { collection, getDocs, getDoc, doc, query, where, onSnapshot, addDoc, arrayUnion, setDoc, updateDoc } from "firebase/firestore";
import { db } from '../../firebase'





const CSV_FILE_URL = 'https://misaa.org.in/misaa_membership_list.csv'




function UserDashboard(props) {




    const [numPages, setNumPages] = useState(null);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };


    const [selectedImage, setSelectedImage] = useState(null);
    const { logOut } = useUserAuth()
    const [photoURL, setPhotoURL] = useState()
    const navigate = useNavigate()
    const { user, state: { cart } } = useUserAuth();
    const userCollectionRef = collection(db, "newusers")
    const [labtests, setLabtests] = useState([])
    const labtestRef = collection(db, "Labtests")
    const [consults, setConsults] = useState([])
    const consultRef = collection(db, "Consults")
    const [checkups, setCheckups] = useState([])
    const checkupRef = collection(db, "Checkups")
    const [userinfo, setUserInfo] = useState([]);
    const [appointmentinfo, setAppointmentInfo] = useState([]);
    const [labtestbookinfo, setLabtestbookinfo] = useState([]);
    const userLabtestBookingRef = collection(db, "LabtestBookings")
    // const userBookingRef = collection(db, "AllBookings")
    const [consultbookinfo, setConsultbookinfo] = useState([]);
    const [checkupbookinfo, setCheckupbookinfo] = useState([]);


    const [userss, setUser] = useState([])

    const [imageUpload, setImageUpload] = useState(null);
    const [imageList, setImageList] = useState([]);

    const [pdfUpload, setPdfUpload] = useState(null);
    const [PdfList, setPdfList] = useState([]);

    const downloadFileAtURL = (url) => {
        const fileName = url.split('/').pop()
        const aTag = document.createElement('a')
        aTag.href = url
        aTag.setAttribute('download', fileName)
        document.body.appendChild(aTag)
        aTag.click();
        aTag.remove();
    };




    useEffect(() => {
        const f = collection(db, "newusers");
        const pp = query(f, where("email", "==", user.email));
        onSnapshot(pp, (snapshot) => {
            let u = []
            snapshot.docs.forEach((doc) => {
                u.push({ ...doc.data(), id: doc.id })
            })
            // console.log(users)
            setUser(u)
        })
    }, []);

    var photoRef
    userss.map((uinfo) => {
        const f = doc(db, "newusers", uinfo.email)
        photoRef = f
    })
    let p = [];
    userinfo.map((url) => {
        p = url.records
    })



    const uploadPDF = () => {
        if (pdfUpload == null) return;

        const pdfRef = ref(storage, `pdfs/${pdfUpload.name + "_" + uuidv4()}`);

        uploadBytes(pdfRef, pdfUpload)
            .then((snapshot) => {
                return getDownloadURL(snapshot.ref);
            })
            .then((url) => {
                return updateDoc(photoRef, {
                    records: arrayUnion(url)
                }).then(() => {
                    setPdfList((prev) => [...prev, url]);
                    alert("PDF Uploaded Successfully");
                });
            })
            .catch((error) => {
                console.error("PDF upload failed:", error);
                alert("Failed to upload PDF");
            });
    };






    useEffect(() => {
        const ref = collection(db, "newusers");
        const q = query(ref, where("email", "==", user.email));
        onSnapshot(q, (snapshot) => {
            let users = []
            snapshot.docs.forEach((doc) => {
                users.push({ ...doc.data(), id: doc.id })
            })
            // console.log(users)
            setUserInfo(users)
        })
    }, [])

    useEffect(() => {
        const newref = collection(db, "Appointments");
        const q = query(newref, where("email", "==", user.email));
        onSnapshot(q, (snapshot) => {
            let appointments = []
            snapshot.docs.forEach((doc) => {
                appointments.push({ ...doc.data(), id: doc.id })
            })

            setAppointmentInfo(appointments)
            //  console.log(appointments)
        })
    }, [])

    useEffect(() => {
        const ref = collection(db, "LabtestBookings");
        const b = query(ref, where("email", "==", user.email));
        onSnapshot(b, (snapshot) => {
            let labtestbooking = []
            snapshot.docs.forEach((doc) => {
                labtestbooking.push({ ...doc.data(), id: doc.id })
            })
            // console.log(labtestbooking)
            setLabtestbookinfo(labtestbooking)
        })
    }, [])

    useEffect(() => {
        const ref = collection(db, "ConsultBookings");
        const g = query(ref, where("email", "==", user.email));
        onSnapshot(g, (snapshot) => {
            let consultbooking = []
            snapshot.docs.forEach((doc) => {
                consultbooking.push({ ...doc.data(), id: doc.id })
            })
            // console.log(consultbooking)
            setConsultbookinfo(consultbooking)
        })
    }, [])


    // useEffect(() => {
    //   const ref =collection(db,"AllBookings");
    //   const b = query(ref, where("email", "==", user.email), where("type", "==", "labtest"));
    //   onSnapshot(b,(snapshot) => {
    //     let labtestbooking=[]
    //     snapshot.docs.forEach((doc)=>{
    //       labtestbooking.push({...doc.data(),id:doc.id})
    //     })
    //     // console.log(labtestbooking)
    //     setLabtestbookinfo(labtestbooking)
    //   })
    // },[])

    // useEffect(() => {
    //   const ref =collection(db,"AllBookings");
    //   const g = query(ref, where("email", "==", user.email), where("type", "==", "consult"));
    //   onSnapshot(g,(snapshot) => {
    //     let consultbooking=[]
    //     snapshot.docs.forEach((doc)=>{
    //       consultbooking.push({...doc.data(),id:doc.id})
    //     })
    //     // console.log(consultbooking)
    //     setConsultbookinfo(consultbooking)
    //   })
    // },[])

    // useEffect(() => {
    //   const ref =collection(db,"AllBookings");
    //   const m = query(ref, where("email", "==", user.email), where("type", "==", "checkup"));
    //   onSnapshot(m,(snapshot) => {
    //     let checkupbooking=[]
    //     snapshot.docs.forEach((doc)=>{
    //       checkupbooking.push({...doc.data(),id:doc.id})
    //     })
    //     // console.log(consultbooking)
    //     setCheckupbookinfo(checkupbooking)
    //   })
    // },[])


    useEffect(() => {
        const ref = collection(db, "ConsultBookings");
        const g = query(ref, where("email", "==", user.email));
        onSnapshot(g, (snapshot) => {
            let consultbooking = []
            snapshot.docs.forEach((doc) => {
                consultbooking.push({ ...doc.data(), id: doc.id })
            })
            // console.log(consultbooking)
            setConsultbookinfo(consultbooking)
        })
    }, [])

    const [userr, setUserr] = useState()
    const params = useParams()
    useEffect(() => {
        getData()
    }, [])
    async function getData() {
        try {
            const userrTemp = await getDoc(doc(db, 'newusers', params.userId))
            setUserr(userrTemp.data())

        } catch (error) {
            console.log(error.message)
        }
    }

    const { dispatch } = useUserAuth();
    useEffect(() => {
        const getlabtests = async () => {
            const data = await getDocs(labtestRef);
            setLabtests(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
        }
        getlabtests()
    }, [])

    useEffect(() => {
        const getconsults = async () => {
            const data = await getDocs(consultRef);
            setConsults(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
        }
        getconsults()
    }, [])


    const [total, setTotal] = useState();

    useEffect(() => {
        setTotal(
            cart.reduce((acc, curr) => acc + Number(curr.price) * curr.qty, 0)
        );
    }, [cart]);


    //Razorpay integration
    function loadScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement('script')
            script.src = src
            script.onload = () => {
                resolve(true)
            }
            script.onerror = () => {
                resolve(false)
            }
            document.body.appendChild(script)
        })
    }
    async function displayRazorpay(amount) {
        const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js')

        if (!res) {
            alert('Razorpay SDK failed to load. Are you online?')
            return
        }

        const options = {
            // key: 'rzp_test_m1pxa5JKJbAV4p',
            key: 'rzp_live_dsnDbV7kqj8n52',
            currency: 'INR',
            amount: total * 100,
            name: 'Uniaone Family Payment',
            description: 'Razorpay Payment Gateway',
            image: "",
            handler: function (response) {
                alert(response.razorpay_payment_id)
                alert("Payment Succesfull")

                if (response.razorpay_payment_id) {
                    cart.map((i) => {
                        const usertestinfo = {
                            "email": user.email,
                            "detail": i.detail,
                            "name": i.name,
                            "price": i.price,
                            // "type": i.type
                        }
                        // addDoc(userBookingRef, usertestinfo)
                        addDoc(userLabtestBookingRef, usertestinfo)
                    })




                }


            },
            // if(response.razorpay_payment_id){

            // }
            prefill: {
                email: user.email,
            }
        }
        const paymentObject = new window.Razorpay(options)
        paymentObject.open()
    }
    const emailVerified = user.emailVerified;

    const handleLogOut = async () => {
        try {
            await logOut()
            window.location.reload()
            navigate("/")
        } catch (err) {

        }
    }



    return (
        <>

            <Header />
      
            <br />
            <br />
            <br />
            <br />
            <div className='album py-2'>
                <div className='container'>
                    <ul className="nav nav-pills mb-3 text-light shadow me-4 " id="pills-tab" role="tablist">
                        <li className="nav-item me-4" role="presentation">
                            <button className="nav-link active me-4" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Dashborad</button>
                        </li>

                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="pills-numberupdate-tab" data-bs-toggle="pill" data-bs-target="#pills-numberupdate" type="button" role="tab" aria-controls="pills-numberupdate" aria-selected="false">Help Desk </button>
                        </li>
                    </ul>
                    <div class="tab-content" id="pills-tabContent">
                        <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">

                            <div className='userinfo'>

                                {userinfo.map((uinfo) => {
                                    return (
                                        <div key={userinfo.id} style={{ margin: 30 }}>
                                            <h4 style={{ color: "green" }}> <center> Welcome to<b className='blink'> {uinfo.fullname}</b> </center></h4>
                                            <h5 style={{ color: "darkBlue" }}>
                                                <center>
                                                    Your email : {uinfo.email}
                                                </center>
                                            </h5>
                                            <h4 style={{ color: "grey" }}>
                                                <center>
                                                    <b>Your mobile : {uinfo.mobile}</b>
                                                </center>
                                            </h4>
                                        </div>
                                    )
                                })}
                            </div>


                            <br />

                            <div className='background'>
                                <div className="album py-3">
                                    <div className="container">
                                        <div className="row">

                                            <div className="col-md-12 mt-3">

                                              
                                                    <div className="album py-2">

                                                        <input type="file"

                                                            onChange={(event) => {
                                                                setPdfUpload(event.target.files[0])
                                                            }}
                                                        />
                                                        <button className='pdfbutton mt-3' onClick={uploadPDF}>Upload PDF</button><br /><br />
                                                        {p.map((n) => {
                                                            return (

                                                                <a href={n} download target="_blank" rel="noopener noreferrer">
                                                                    <button style={{ margin: "3px" }} className="pdf">Download PDF <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
</svg></button>
                                                                </a>







                                                            )
                                                        })}


                                                    </div>
                                                


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {emailVerified ? (

                                <div className='right'>

                                    {appointmentinfo.map((ainfo) => {
                                        return (
                                            <div key={appointmentinfo.id} style={{ margin: 30 }}>

                                                <h3 style={{ margin: 30 }}>You Have Appointment With Dr. {ainfo.Appointment_with}</h3>
                                                <h3 style={{ margin: 30 }}>At : {ainfo.Time} </h3>
                                                <h3 style={{ margin: 30 }}>Date: {ainfo.Date}</h3>
                                            </div>
                                        )
                                    })}




                                    <div className="album py-3">
                                        <div className="container">
                                            <div className="row" >
                                                {labtestbookinfo.map((labinfo) => {

                                                    return (
                                                        <div className="col-6" key={labinfo.id}>
                                                            <div className="card mb-4 border-primary box shadow ">

                                                                <div className="card-body">
                                                                    <h5 className="card-text">{labinfo.name}</h5>
                                                                    <p className="card-text">{labinfo.detail}</p>
                                                                    <h6 className="card-text">₹{labinfo.price}</h6>
                                                                    <h6 className="card-text">{labinfo.type}</h6>
                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>


                                    <div className="album py-3">
                                        <div className="container">
                                            <div className="row" >
                                                {consultbookinfo.map((consainfo) => {

                                                    return (
                                                        <div className="col-6" key={consainfo.id}>
                                                            <div className="card mb-4 border-primary box shadow ">

                                                                <div className="card-body">
                                                                    <p className="card-text">{consainfo.detail}</p>
                                                                    <h6 >₹{consainfo.price}</h6>

                                                                </div>
                                                            </div>
                                                        </div>

                                                    )
                                                })}
                                            </div>
                                        </div>

                                    </div>

                                    <div className="album py-0">
                                        <div className="container">
                                            <div className="row" >
                                                {checkupbookinfo.map((checkinfo) => {

                                                    return (
                                                        <div className="col-6" key={checkinfo.id}>
                                                            <div className="card mb-4 border-primary box shadow ">

                                                                <div className="card-body">
                                                                    <p className="card-text">{checkinfo.detail}</p>
                                                                    <h6 >₹{checkinfo.price}</h6>

                                                                </div>
                                                            </div>
                                                        </div>

                                                    )
                                                })}
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            ) : (
                                <div className='right'>
                                    <h5 style={{ display: "block", margin: 50 }}>You Need to Verify your Email to see the Appointments</h5>

                                </div>
                            )
                            }

                        </div>




                        <br />
                        <div class="tab-pane fade" id="pills-numberupdate" role="tabpanel" aria-labelledby="pills-numberupdate-tab">
                            <center>
                                <h4 style={{ color: "#00809D" }}> Anywhere, At any time Email or call if you have a tech releted problem.</h4><br />
                            </center>
                            <div className="album py-2">

                                <div className="container">

                                    <div className="row">
                                        <div className="col-md-6 ">
                                            <div className="card mb-4">
                                                <div className="card-body">
                                                    <a href='mailto: info@prothama.com'>
                                                        <h5 style={{ color: "#00809D", textAlign: "center" }}>Official Email Id: <button className="infomail"> info@prothama.com </button></h5>
                                                    </a>
                                                    <div className="d-flex justify-content-between align-items-center">


                                                    </div>

                                                </div>


                                            </div>


                                        </div>
                                        <div className="col-md-6 ">
                                            <div className="card mb-4">
                                                <div className="card-body">

                                                    <h5 style={{ textAlign: "center" }}>Help Line Number <a href="tel:+91 8348222208" className="btn btn- btn-outline-">+91 83482 22208</a></h5>
                                                    <div className="d-flex justify-content-between align-items-center">


                                                    </div>

                                                </div>


                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div >
            </div >




            {/* <div className='doc-div' style={{ display: "flex", justifyContent: "space-between"}}>
          <div className='left'> */}





            {/* </div>
      
      </div> */}


            {/* 
      <div className='dashboard'>
        
    
        <h4 style={{textAlign: "center"}}> Welcome {user.email}</h4>
       
        <br></br> 

    

        <div className='doc-div' style={{ display: "flex", justifyContent: "space-between"}}>
          <div className='left'>
            <h4 style={{margin:30}}>Your Orders</h4>  
            {cart.length > 0 ?(
              <> 
                <div className='cart'>
                  <div className="labs">
                  {cart.map((labtest) => { return (
                      <div className="col" key={labtest.id}>
                        <div className="test1">
                          <div className="card text-center" >
                            <div className="card-body">
                              <h5 className="card-title">{labtest.name}</h5>
                              <p className="card-text">{labtest.detail}</p>
                              <h6 >₹{labtest.price}</h6>
                              <button onClick={ () =>
                                dispatch({
                                  type: "REMOVE_FROM_CART",
                                  payload: labtest,
                                })} className='btn btn-danger'>Remove</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )})}
                    </div>
                    <div className='checkout' style={{margin:30}}>
                      <span style={{ fontWeight: 700, fontSize: 20 }}>Total: ₹ {total}</span>
                      <Button  onClick={displayRazorpay} style={{margin:30}} type="button" disabled={cart.length === 0}>
                        Proceed to Checkout
                      </Button>
                    </div>
                  
                </div>
                
              </>
            ):(
              <h2 style={{margin:30}}>Cart is Empty!!!</h2>
            )}
          </div>
          <div className='right'>
            <h4 style={{margin:30, color: "blue"}}>Yours Appointments</h4>

          </div>
        </div>

     
       


      
      </div>
     */}



        </>
    )
}

export default UserDashboard